<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1> G. H. Raisoni Memorial Jalna Rapid Chess Tournament 2025 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span> The G. H. Raisoni Memorial Jalna Rapid Chess Tournament 2025 was successfully</span>
            </h2>
        </div>
        <p>The G. H. Raisoni Memorial Jalna Rapid Chess Tournament 2025 was successfully organized by Glorious Chess
            Academy, Jalna at Shree Chaitanya Techno School, Manish Nagar, Jalna.
        </p>
        <p>In a competitive display of chess skills, Ashish Chaudhary from Ahmednagar emerged as the Champion, while
            Vaibhav Lokhande from Chhatrapati Sambhajinagar secured the Runner-up position.</p>
        <p>The tournament witnessed enthusiastic participation from around 120 players, including nearly 50
            internationally rated players. Participants came from various cities and towns across Maharashtra, as well
            as from Madhya Pradesh and Andhra Pradesh, adding to the tournament’s prestige.</p>
        <p>The total prize fund was ₹30,000 in cash, along with 74 trophies and medals distributed among the top
            performers. All participants were also awarded participation certificates based on their performance.</p>
        <p>The prize distribution ceremony was graced by dignitaries including Principal Madam of Shree Chaitanya
            School, Mr. Makarand Shahapurkar, Director of Jalna Digital Orbit, and Mr. Lahane Sir, who felicitated the
            winners.</p>
        <hr>
        <h5 class="primary-purple">Key contributors to the success of the event included:</h5>
        <ul class="list-style list-style1 mb-3  ">
            <p><strong>Tournament Director: </strong></p>
            <li> Mr. Satish Thakur</li>
        </ul>
        <ul class="list-style list-style1 mb-3  ">
            <p><strong>Chief Arbiter:</strong></p>
            <li> Mr. Krishna Thakur </li>
        </ul>
        <ul class="list-style list-style1 mb-3  ">
            <p><strong>Arbiters:</strong></p>
            <li>Mr. Sagar Gandhi (Ahilyanagar) </li>
            <li>Mr. Vilas Rajput (Chhatrapati Sambhajinagar)</li>
            <li> Mr. Sujal Lodhi</li>
        </ul>
        <ul class="list-style list-style1 mb-3  ">
            <p><strong>Event Managers:</strong></p>
            <li> Mr. Vijay Thakur</li>
            <li>Mr. Sachin Giri</li>
            <li>Mr. Vishal Shinde</li>
        </ul>
        <ul class="list-style list-style1 mb-3  ">
            <p><strong>Support Staff:</strong></p>
            <li> Shree Chaitanya School staff</li>
        </ul>
        <p>Special thanks to Raisoni Foundation, Nagpur, and Kalpana Prakash Welfare Foundation’s Mr. Bhushan Shriwas
            for sponsoring the cash prizes and extending their valuable support to the event.</p>
        <p>The tournament marked another milestone in promoting chess excellence in the region and concluded on a highly
            successful note.</p>

        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/sambhaji-ngr-chess-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/sambhaji-ngr-chess-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/sambhaji-ngr-chess-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/sambhaji-ngr-chess.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/sambhaji-ngr-chess.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/sambhaji-ngr-chess.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</section>
